import { inject, onMounted, onUnmounted, ref } from 'vue';
import { ModalOpened } from '@/common/domain/modal/ModalOpened';
import { modalBusKey } from '@/common/domain/modal/ModalBus';
import { globalWindowKey } from '@/common/domain/Window';
import { Unsubscribe } from '@/common/domain/Unsubscribe';

export default {
  name: 'Modal',

  setup() {
    const globalWindow = inject(globalWindowKey)!;
    const modalBus = inject(modalBusKey)!;

    const isModalOpened = ref<boolean>(false);
    const modal = ref();
    let unsubscribeOpenModal: Unsubscribe;
    let unsubscribeCloseModal: Unsubscribe;

    const closeOnEscape = (event: KeyboardEvent): void => {
      if (event.key === 'Escape') {
        modalBus.close();
      }
    };

    onMounted(async () => {
      globalWindow.document.addEventListener('keyup', closeOnEscape);
      unsubscribeOpenModal = modalBus.opened(openModal);
      unsubscribeCloseModal = modalBus.closed(closeModal);
    });

    onUnmounted(() => {
      globalWindow.document.removeEventListener('keyup', closeOnEscape);
      unsubscribeOpenModal();
      unsubscribeCloseModal();
    });

    const openModal = (modalOpened: ModalOpened<any>) => {
      modal.value = modalOpened;
      isModalOpened.value = true;
    };

    const closeModal = () => {
      isModalOpened.value = false;
    };

    const stopPropagation = (event: MouseEvent) => {
      event.stopPropagation();
    };

    return {
      isModalOpened,
      modal,
      openModal,
      closeModal,
      stopPropagation,
    };
  },
};
